export default {
  invalidEmail: "Indirizzo email non valido",
  passwordRequired: "La password è obbligatoria",
  invalidLogin:
    "Email o password non corretti. Riprova oppure usa «Password dimenticata» per reimpostarla.",
  accountDisabled:
    "Questo account è stato disattivato. Contatta il supporto se ti serve aiuto.",
  kioskRevoked:
    "L’accesso tablet è stato revocato. Chiedi nuove credenziali all’amministratore della struttura.",
  softwareIdRequired:
    "Questo accesso richiede un identificativo dispositivo. Usa l’accesso tramite QR dal dispositivo della struttura oppure contatta il supporto.",
  loginSuccess: "Accesso effettuato!",
  partnerPortal: "Portale venditori",
  heroTitleLine1: "Gestisci la tua",
  heroTitleLine2: "attività con facilità",
  heroSubtitle:
    "Il portale dedicato ai venditori per gestire prenotazioni, attività e guadagni in un unico posto.",
  statPartners: "Venditori attivi",
  statBookings: "Prenotazioni/mese",
  welcomeBack: "Bentornato!",
  signInSubtitle: "Accedi al tuo account per continuare",
  email: "Email",
  emailPlaceholder: "nome@esempio.com",
  password: "Password",
  passwordPlaceholder: "••••••••",
  showPassword: "Mostra password",
  hidePassword: "Nascondi password",
  showConfirmPassword: "Mostra conferma password",
  hideConfirmPassword: "Nascondi conferma password",
  signIn: "Accedi",
  forgotPasswordLink: "Password dimenticata?",
  forgotPasswordTitle: "Password dimenticata",
  forgotPasswordSubtitle:
    "Inserisci l’email dell’account. Se corrisponde a un account del portale venditori, invieremo un link per reimpostarla.",
  forgotPasswordSubmit: "Invia link di reset",
  forgotPasswordSuccessToast: "Se l’indirizzo è valido, controlla la posta.",
  forgotPasswordCheckEmail:
    "Se l’indirizzo è valido, abbiamo inviato le istruzioni alla tua casella di posta.",
  forgotPasswordRulesReminder:
    "La nuova password dovrà avere almeno {{min}} caratteri e includere maiuscole e minuscole, un numero e un carattere speciale.",
  setPasswordTitle: "Imposta la password",
  setPasswordChecking: "Verifica del link in corso…",
  setPasswordInvalidLink:
    "Questo link non è valido o è scaduto. Chiedi un nuovo invito allo staff oppure richiedi il reset dalla pagina di accesso.",
  setPasswordRequirementsTitle: "Requisiti della password",
  setPasswordRequirementMinLength: "Almeno {{min}} caratteri",
  setPasswordRequirementMixedCase: "Lettere maiuscole e minuscole (A–z)",
  setPasswordRequirementDigit: "Almeno un numero",
  setPasswordRequirementSpecial: "Almeno un carattere speciale (es. ! @ #)",
  setPasswordTooCommonToast:
    "Questa password è troppo facile da indovinare. Scegline una più forte e meno comune.",
  setPasswordSubmit: "Salva password",
  setPasswordSuccessToast: "Password impostata. Ora puoi accedere.",
  setPasswordDone: "Password salvata. Puoi chiudere questa pagina e accedere.",
  newPassword: "Nuova password",
  confirmPassword: "Conferma password",
  passwordConfirmRequired: "Conferma la password",
  passwordsDoNotMatch: "Le password non coincidono",
  setPasswordMinLength: "La password deve avere almeno {{min}} caratteri",
  setPasswordMixedCase: "Includi lettere maiuscole e minuscole (A–z)",
  setPasswordRequireDigit: "Includi almeno un numero",
  setPasswordRequireSpecial: "Includi almeno un carattere speciale (es. ! @ #)",
  backToLogin: "Torna all’accesso",
  testCredentialsTitle: "Credenziali di test",
} as const;
